import styled from 'styled-components'
import { Media, mbSize } from '@foxrenderfarm/common'

export const TableOfContents = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  padding: 12px 8px 12px 16px;
`

export const SliderTrack = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #e8e8e8;
`

export const SliderIndicator = styled.div`
  position: absolute;
  left: 0;
  width: 1px;
  background-color: #f3512b;
  border-radius: 2px;
  transition:
    transform 0.3s ease,
    height 0.3s ease;
  will-change: transform;
`

export const TocItem = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
`

export const TocSubItem = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  font-size: 14px;
`

export const TocLink = styled.a<{ $active?: boolean }>`
  font-family: 'MarkPro';
  line-height: 20px;
  color: ${(props) => (props.$active ? '#F3512B' : '#333333')};
  text-decoration: none;
  position: relative;
  transition: color 0.2s ease;
  cursor: pointer;
  z-index: 1;

  &:hover {
    color: #f3512b;
  }

  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    line-height: ${mbSize(34)};
  }
`
